<!--Copyright (c) Method Development, LLC.  All rights reserved.-->
<!--<pre class="debug"><code>{JSON.stringify(xsrfToken)}</code></pre>-->
<!--<pre class="debug"><code>{JSON.stringify(model)}</code></pre>-->
<!--<pre class="debug"><code>{JSON.stringify(helper)}</code></pre>-->

<div class="container">

    <div class="col col-md-6 offset-md-3">

        <div class="row">

            <div class="col mb-3">
                <h1>Login</h1>
                <p class="fs-6 mb-0">Welcome to the SWSF Education App. Please login with your credentials below:</p>
            </div>

        </div>

        <ul class="validation-summary" aria-live="assertive"></ul>

        <div class="row">

            <div class="col mb-3">
                <label for="username">Username</label>
                <input type="text" id="username" name="username" class="form-control" autocomplete="on" value="{ model.username }" on:input="{ (e) => model.username = e.target.value }" on:focus="{ () => keyboard(true,post) }" on:blur="{ () => keyboard(false,post) }" aria-required="true" />
                <a id="forgotUsername" href="/forgotusername" title="Forgot Username">Forgot Username?</a>
            </div>

        </div>

        <div class="row">

            <div class="col mb-3">
                <label for="password">Password</label>
                <input type="password" id="password" name="password" class="form-control" autocomplete="current-password" value="{ model.password }" on:input="{ (e) => model.password = e.target.value }" on:focus="{ () => keyboard(true,post) }" on:blur="{ () => keyboard(false,post) }" aria-required="true" />
                <a id="forgotPassword" href="/forgotpassword" title="Forgot Password">Forgot Password?</a>
            </div>

        </div>

        <div class="row">

            <div class="col text-center">
                <button id="login" type="button" class="btn btn-primary" on:click="{post}" disabled="{ helper.spinner === true }"><i class="{ helper.spinner === true ? 'fa-solid fa-spinner fa-spin show' : 'hide' }"></i> Login</button>
            </div>

        </div>

    </div>

</div>

<script>
    import { urlIdentity } from "../lib/url.js";
    import { helperFetch, keyboard } from "../lib/common.js";

    //validation summary: visible
    addEventListener("validationVisibility", (e) => {
        helperFetch.validationSummaryVisible = e.detail.validationSummaryVisible;
    });

    export let xsrfToken = null;

    let model = {
        username: null,
        password: null
    };

    let helper = {
        spinner: false
    };

    const post = () => {

        //ui
        helper.spinner = true;

        fetch(urlIdentity.api.login, {
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: xsrfToken,
            },
            body: JSON.stringify(model)
        })
            .then(helperFetch.fetchHandler)
            .then(response => {

                //ui
                helper.spinner = false;
            })
            .catch(error => {

                //handle
                helperFetch.errorHandler(error);

                //ui
                helper.spinner = false;
            });
    };

</script>
